import { UISelectorType } from "../../../utilities/types";
import { VoiceCategory, VoiceCustomizationEntry, VoiceSubCategory } from "./types";

export const voiceCustomizeEntries: VoiceCustomizationEntry[] = [
    // Call behavior
    {
        id: 'voiceSnippetToChatOnClose',
        displayName: 'Close Button Behavior',
        category: VoiceCategory.CallBehavior,
        subCategory: VoiceSubCategory.Common,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'agentName',
        displayName: 'Voice agent name',
        category: VoiceCategory.CallBehavior,
        subCategory: VoiceSubCategory.Identity,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'voiceBotVolume',
        displayName: 'Agent volume (0-1)',
        category: VoiceCategory.CallBehavior,
        subCategory: VoiceSubCategory.AudioLevels,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'voiceMicVolume',
        displayName: 'Microphone volume (0-1)',
        category: VoiceCategory.CallBehavior,
        subCategory: VoiceSubCategory.AudioLevels,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'voiceTimerEnabled',
        displayName: 'Show call timer',
        category: VoiceCategory.CallBehavior,
        subCategory: VoiceSubCategory.CallInformation,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'voiceTranscriptEnabled',
        displayName: 'Show transcript button',
        category: VoiceCategory.CallBehavior,
        subCategory: VoiceSubCategory.CallInformation,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "VoiceUI",
    },

    // Outbound calls
    {
        id: 'outboundCallDelayMs',
        displayName: 'Outbound call delay (ms)',
        category: VoiceCategory.OutboundCalls,
        subCategory: VoiceSubCategory.CampaignsAndTiming,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'outboundCampaigns',
        displayName: 'Outbound campaigns (name and ID)',
        category: VoiceCategory.OutboundCalls,
        subCategory: VoiceSubCategory.CampaignsAndTiming,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
        multiline: true,
    },
    {
        id: 'showOutboundCallButton',
        displayName: 'Show outbound call button',
        category: VoiceCategory.OutboundCalls,
        subCategory: VoiceSubCategory.CampaignsAndTiming,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'outboundCallingAnimation',
        displayName: 'Calling animation',
        category: VoiceCategory.OutboundCalls,
        subCategory: VoiceSubCategory.CallAnimations,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'outboundPrepareAnimation',
        displayName: 'Preparing-call animation',
        category: VoiceCategory.OutboundCalls,
        subCategory: VoiceSubCategory.CallAnimations,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "VoiceUI",
    },

    // Window
    {
        id: 'minWidth',
        displayName: 'Minimum voice window width',
        category: VoiceCategory.Window,
        subCategory: VoiceSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'height',
        displayName: 'Voice window height',
        category: VoiceCategory.Window,
        subCategory: VoiceSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'maxHeight',
        displayName: 'Voice window maximum height',
        category: VoiceCategory.Window,
        subCategory: VoiceSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'maxWidth',
        displayName: 'Voice window maximum width',
        category: VoiceCategory.Window,
        subCategory: VoiceSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'minHeight',
        displayName: 'Voice window minimum height',
        category: VoiceCategory.Window,
        subCategory: VoiceSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'width',
        displayName: 'Voice window width',
        category: VoiceCategory.Window,
        subCategory: VoiceSubCategory.Size,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
    },

    // Appearance
    {
        id: 'tone',
        displayName: 'Surface darkness (0-100)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Theme,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'theme',
        displayName: 'Voice theme',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Theme,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'accent',
        displayName: 'Accent color',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'primary',
        displayName: 'Primary color',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'secondary',
        displayName: 'Secondary color',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'background',
        displayName: 'Ambient background intensity (0-100)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'blur',
        displayName: 'Ambient blur (px)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'glow',
        displayName: 'Ambient glow (0-100)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'spread',
        displayName: 'Ambient spread (0-100)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'animation',
        displayName: 'Animation',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.dropDownSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'intensity',
        displayName: 'Animation intensity (0-100)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'angle',
        displayName: 'Gradient angle (degrees)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'stop',
        displayName: 'Secondary color stop (0-100)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.GradientAndAnimation,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'voiceOrbSize',
        displayName: 'Orb size (px)',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Orb,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'fontSizeLarge',
        displayName: 'Large text size',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Typography,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'fontSizeMedium',
        displayName: 'Medium text size',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Typography,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'fontSizeSmall',
        displayName: 'Small text size',
        category: VoiceCategory.Appearance,
        subCategory: VoiceSubCategory.Typography,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },

    // Call controls
    {
        id: 'controlButtonBackdropBlur',
        displayName: 'Backdrop blur (px)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonSize',
        displayName: 'Button size (px)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonsGap',
        displayName: 'Buttons gap (px)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlPaddingTopBottom',
        displayName: 'Padding top and bottom (px)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Layout,
        uiSelectorType: UISelectorType.integerSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonBackgroundColor',
        displayName: 'Background color',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonActiveBackgroundColor',
        displayName: 'Background color (active)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonBackgroundColorOnHover',
        displayName: 'Background color (hover)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonBorderColor',
        displayName: 'Border color',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'hangupButtonBackgroundColor',
        displayName: 'Hang-up button background',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'hangupButtonIconColor',
        displayName: 'Hang-up button icon color',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlHangupButtonColor',
        displayName: 'Hang-up pill text and icon color',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonIconColor',
        displayName: 'Icon color',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'controlButtonActiveIconColor',
        displayName: 'Icon color (active)',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Colors,
        uiSelectorType: UISelectorType.colorSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'v2_hangup_icon',
        displayName: 'Hang-up icon',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
        multiline: true,
    },
    {
        id: 'v2_microphone_icon',
        displayName: 'Microphone icon',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
        multiline: true,
    },
    {
        id: 'v2_microphone_muted_icon',
        displayName: 'Microphone muted icon',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
        multiline: true,
    },
    {
        id: 'v2_orb_icon',
        displayName: 'Orb icon',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
        multiline: true,
    },
    {
        id: 'v2_transcript_icon',
        displayName: 'Transcript icon',
        category: VoiceCategory.CallControls,
        subCategory: VoiceSubCategory.Icons,
        uiSelectorType: UISelectorType.defaultSelector,
        containerName: "VoiceUI",
        multiline: true,
    },

    // Localization
    {
        id: 'localization',
        displayName: 'Localization',
        category: VoiceCategory.Localization,
        subCategory: VoiceSubCategory.InterfaceText,
        uiSelectorType: UISelectorType.localizationSelector,
        containerName: "VoiceUI",
    },

    // Header
    {
        id: 'voiceSwitchToChatButtonEnabled',
        displayName: 'Show switch to chat button',
        category: VoiceCategory.Header,
        subCategory: VoiceSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "VoiceUI",
    },
    {
        id: 'voiceSwitchToAvatarButtonEnabled',
        displayName: 'Show switch to avatar button',
        category: VoiceCategory.Header,
        subCategory: VoiceSubCategory.Controls,
        uiSelectorType: UISelectorType.booleanSelector,
        containerName: "VoiceUI",
    }
];
